// Helpers
import { getLocationsForApi } from './campaignEditModal';
// Types
import {
  AudienceFiltersInput,
  AudienceGender,
  AudienceAgeRange,
  AudienceInterest,
  AudienceEthnicity,
  CampaignLocationInput,
} from 'api/graphql-global-types';

export type BuildAudienceFiltersParams = {
  audienceGender?: AudienceGender | null;
  audienceAgeRanges?: AudienceAgeRange[] | null;
  audienceEthnicities?: AudienceEthnicity[] | null;
  audienceLocations?: CampaignLocationInput[] | null;
  audienceInterests?: AudienceInterest[] | null;
  isTikTok?: boolean;
};

export const buildAudienceFilters = (
  params: BuildAudienceFiltersParams
): AudienceFiltersInput | null => {
  const {
    audienceGender,
    audienceAgeRanges,
    audienceEthnicities,
    audienceLocations,
    audienceInterests,
    isTikTok = false,
  } = params;

  const audienceFilters: AudienceFiltersInput = {};

  if (audienceGender) {
    audienceFilters.gender = audienceGender;
  }
  if (audienceAgeRanges && audienceAgeRanges.length > 0) {
    audienceFilters.ageRanges = audienceAgeRanges;
  }
  if (audienceEthnicities && audienceEthnicities.length > 0 && !isTikTok) {
    audienceFilters.ethnicities = audienceEthnicities;
  }
  if (audienceLocations && audienceLocations.length > 0) {
    audienceFilters.locations = getLocationsForApi(audienceLocations, isTikTok);
  }
  if (audienceInterests && audienceInterests.length > 0 && !isTikTok) {
    audienceFilters.interests = audienceInterests;
  }

  return Object.keys(audienceFilters).length > 0 ? audienceFilters : null;
};

export const addAudienceFiltersIfNeeded = <T extends Record<string, any>>(
  target: T,
  params: BuildAudienceFiltersParams
): T & { audienceFilters?: AudienceFiltersInput } => {
  const audienceFilters = buildAudienceFilters(params);
  if (audienceFilters) {
    return { ...target, audienceFilters };
  }
  return target as T & { audienceFilters?: AudienceFiltersInput };
};
